import { withExpandedProductKeysInFilter } from '../../utility/filter.expansions';
import Moment from 'moment';

export const commonDateParamMappings = [
  {
    path: 'after',
    transform: ({ after }: { after: number }) =>
      after ? Moment.unix(after).startOf('day').toISOString() : null,
  },
  {
    path: 'before',
    transform: ({ before }: { before: number }) =>
      before
        ? Moment.unix(before).endOf('day').toISOString()
        : Moment().endOf('day').toISOString(),
  },
];

/**
 * The `f` (url) / `filter` (direct) → `filter` (api) mapping every listing's service
 * mapping needs.
 *
 * Use this in place of a bare `{ path: 'f', paramKey: 'filter' }` or `{ path: 'filter' }`.
 * Beyond the rename it widens any grouped product key, which is what makes a filter the
 * user did not just build in the modal — a bookmark, a shared link, a refresh, a
 * back-navigation — return the whole Prime 250 book rather than half of it (FPX-8863).
 * The write path's equivalent is `flattenQuery`; this is the read path's.
 *
 * Prefers `f` when present (URL-shaped listing params) and falls back to `filter`
 * (callers that build the API shape directly), so a mapping never needs a second
 * `{ path: 'filter' }` entry that would overwrite the widened value.
 *
 * A mapping that needs its own `transform` cannot use this entry as-is: call
 * `withExpandedProductKeysInFilter` on whatever that transform returns instead.
 */
export const filterParamMapping = {
  path: 'f',
  paramKey: 'filter',
  transform: ({ f, filter }: { f?: unknown; filter?: unknown }) =>
    withExpandedProductKeysInFilter(f ?? filter),
};
